export default {
    listBroadcast: [],
    listMailSendByBroadcastId: [],
    infoDB: {},
}